import { MenuDropdownItem } from './BaseMenuDropdown';

export function HelpDropdownItem() {
  return (
    <MenuDropdownItem asChild>
      <a href="https://support.bolt.new/" target="_blank" rel="noopener noreferrer">
        <span className="i-lucide:circle-question-mark size-4 mt-0.5 group-hover:text-bolt-elements-textPrimary" />
        Help
      </a>
    </MenuDropdownItem>
  );
}
